////////////////////////////////////////////////////////////////////////////////
// Impact theme overwrite
// This will block elements from being defined within theme.js
// Effectively removing or totally overriding the default theme
////////////////////////////////////////////////////////////////////////////////

// remove custom cursor
var CustomCursor = class extends HTMLElement {};
if (!window.customElements.get("custom-cursor")) {
    window.customElements.define("custom-cursor", CustomCursor);
}
